module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Four of the most important battles of the early period of the war were fought in this area during 1915; battles in which – with the exception of Neuve Chapelle which was an entirely British affair – the BEF was very much the junior partner in the Franco-British Alliance. It was a period when the strategic direction of the war on the Western Front was for the most part dictated by the French and their Commander-in-Chief, General Joseph Joffre.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c8397fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/19_fm032.vue
// module id = 114
// module chunks = 0